import { ApplicationRef, inject, Injectable, NgZone } from '@angular/core';
import { animationFrameScheduler } from 'rxjs';
import { isNgZone } from './zone-helpers';


@Injectable({
  providedIn: 'root',
  useFactory: () => {
    const zone = inject(NgZone);
    return isNgZone(zone)
      ? new NoopTickScheduler()
      : inject(AnimationFrameTickScheduler);
  },
})
export abstract class TickScheduler {
  abstract schedule(): void;
}

@Injectable({
  providedIn: 'root',
})
export class AnimationFrameTickScheduler extends TickScheduler {

  readonly #appRef = inject(ApplicationRef);

  private isScheduled = false;

  constructor() {
    super();
  }

  schedule(): void {
    if (!this.isScheduled) {
      this.isScheduled = true;
      animationFrameScheduler.schedule(() => {
        this.#appRef.tick();
        this.isScheduled = false;
      });
    }
  }
}

export class NoopTickScheduler extends TickScheduler {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  schedule(): void {}
}
